<template lang="pug">
v-card(
  class="pa-4"
  outlined
)
  v-form(@submit.prevent="submit")
    v-row
      v-col(cols="6" md="2")
        v-text-field(
          v-model="searchPayload.tableNo" 
          label="桌號"
          hide-details
        )
      v-col(cols="6" md="2")
        v-text-field(
          v-model="searchPayload.name" 
          label="姓名"
          hide-details
        )
      v-col(cols="6" md="2")
        v-select(
          v-model="searchPayload.gender" 
          :items="['男', '女']"
          label="性別"
          hide-details
        )
      v-col(cols="6" md="2")
        v-select(
          v-model="searchPayload.isPay" 
          :items="[{ id: 1, text: '已繳費 '}, { id: 0, text: '未繳費 '}]"
          item-value="id"
          label="繳費"
          hide-details
        )
      v-col(cols="6" md="2")
        v-select(
          v-model="searchPayload.signInStatus" 
          :items="[{ id: 1, text: '已簽到 '}, { id: 0, text: '未簽到 '}]"
          item-value="id"
          label="簽到"
          hide-details
        )
    GroupComponent(:searchGroupId="searchPayload.groupId" @groupId="handleSearchGroup")
    v-row(class="justify-end mt-4")
      v-col(cols="12" md="5")
        v-btn(
          @click.stop="handleSearch"
          type="submit"
          class="ma-2 font-weight-bold text-button" dark color="primary")
          v-icon(dark) mdi-magnify
          span(class="font-weight-bold") 查詢
        v-btn(
          @click.stop="clear"
          class="ma-2 font-weight-bold text-button")
          v-icon mdi-broom
          span(class="font-weight-bold") 清除
        v-btn(
          @click.stop="handleExportTable"
          class="ma-2 font-weight-bold text-button" dark color="green darken-1")
          v-icon(dark) mdi-microsoft-excel
          span(class="font-weight-bold") 匯出分組表
        v-btn(
          @click.stop="handleExportData"
          class="ma-2 font-weight-bold text-button" dark color="green darken-1")
          v-icon(dark) mdi-microsoft-excel
          span(class="font-weight-bold") 匯出報名單
</template>

<script>
import GroupComponent from '@/components/common/group';
export default {
  name: 'userSearchForm',
  components: {
    GroupComponent
  },
  data() {
    return {
      userCreateDialog: false,
      searchPayload: {
        tableNo: null,
        name: null,
        gender: null,
        isPay: null,
        groupId: null,
        signInStatus: null
      }
    }
  },
  methods: {
    submit () {
      this.$emit('search', this.searchPayload)
    },
    clear () {
      this.searchPayload = {
        tableNo: null,
        name: null,
        gender: null,
        isPay: null,
        groupId: null,
        signInStatus: null
      }
      this.submit()
    },
    handleSearch () {
      const payload = {
        tableNo: this.searchPayload.tableNo && this.searchPayload.tableNo !== '' ? this.searchPayload.tableNo : null,
        name: this.searchPayload.name && this.searchPayload.name !== '' ? this.searchPayload.name : null,
        gender: this.searchPayload.gender && this.searchPayload.gender !== '' ? this.searchPayload.gender : null,
        isPay: this.searchPayload.isPay && this.searchPayload.isPay !== '' ? this.searchPayload.isPay : null,
        groupId: this.searchPayload.groupId && this.searchPayload.groupId !== '' ? this.searchPayload.groupId : null,
        signInStatus: this.searchPayload.signInStatus && this.searchPayload.signInStatus !== '' ? this.searchPayload.signInStatus : null,
      }
      this.$emit('search', payload)
    },
    handleSearchGroup (val) {
      this.searchPayload.groupId = val
    },
    handleExportTable () {
      this.$emit('exportTable')
    },
    handleExportData () {
      this.$emit('exportData')
    }
  },
}
</script>
